import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Material.css';
import NotFoundImage from './not-found.png';
import API_URL from '../../api/ExamCalendarApi';
const MaterialManager = () => {
  const [materials, setMaterials] = useState([]);
  const [filteredMaterials, setFilteredMaterials] = useState([]);
  const [show, setShow] = useState(false);
  const [editingMaterial, setEditingMaterial] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');


  const [formData, setFormData] = useState({
    name: '',
    price: '',
    stock: true,
    subtopic: '',
    banner: null,
  });

  // Fetch materials from the server
  useEffect(() => {
    fetchMaterials();
  }, []);

  const fetchMaterials = async () => {
    try {
      const response = await axios.get(`${API_URL}/material/all`);
      setMaterials(response.data);
      setFilteredMaterials(response.data);
    } catch (error) {
      console.error('Error fetching materials', error);
    }
  };

  // Handle form input changes
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
  };

  // Handle file input change (banner image)
  const handleFileChange = (e) => {
    setFormData({
      ...formData,
      banner: e.target.files[0],
    });
  };

  // Show modal for adding/editing material
  const handleShow = (material = null) => {
    setEditingMaterial(material);
    if (material) {
      setFormData({
        name: material.name,
        price: material.price,
        stock: material.stock,
        subtopic: material.subtopic || '',
        banner: null,
      });
    } else {
      setFormData({
        name: '',
        price: '',
        stock: true,
        subtopic: '',
        banner: null,
      });
    }
    setShow(true);
  };

  // Close modal
  const handleClose = () => setShow(false);

  // Submit form (add or edit)
  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataObj = new FormData();
    formDataObj.append('name', formData.name);
    formDataObj.append('price', formData.price);
    formDataObj.append('stock', formData.stock);
    formDataObj.append('subtopic', formData.subtopic);
    if (formData.banner) formDataObj.append('banner', formData.banner);

    try {
      if (editingMaterial) {
        // Edit existing material
        await axios.put(`${API_URL}/material/edit/${editingMaterial._id}`, formDataObj);
      } else {
        // Add new material
        await axios.post(`${API_URL}/material/add`, formDataObj);
      }
      fetchMaterials();
      handleClose();
    } catch (error) {
      console.error('Error saving material', error);
    }
  };

  // Delete material
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this material?')) {
      try {
        await axios.delete(`${API_URL}/material/delete/${id}`);
        fetchMaterials();
      } catch (error) {
        console.error('Error deleting material', error);
      }
    }
  };

  // Handle search query input
  const handleSearchChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    setFilteredMaterials(
      materials.filter((material) =>
        material.name.toLowerCase().includes(query)
      )
    );
  };

  return (
    <div className="admin-materials-container">
      <div className="admin-materials-section">
        <h1>Material Management</h1>
        <input
          type="text"
          placeholder="Search materials..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="admin-materials-search"
        />
        <button className="admin-materials-btn-primary" onClick={() => handleShow()}>
          Add Material
        </button>
        <div className="admin-materials-table-wrapper">
          <table className="admin-materials-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Stock</th>
                <th>Subtopic</th>
                <th>Banner</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filteredMaterials.length > 0 ? (
                filteredMaterials.map((material) => (
                  <tr key={material._id}>
                    <td>{material.name}</td>
                    <td>{material.price}</td>
                    <td>{material.stock ? 'In Stock' : 'Out of Stock'}</td>
                    <td>{material.subtopic || 'N/A'}</td>
                    <td>
                      <img
                        src={material.banner}
                        alt={material.name}
                        className="admin-materials-banner-img"
                      />
                    </td>
                    <td>
                      <button
                        className="admin-materials-btn-warning"
                        onClick={() => handleShow(material)}
                      >
                        Edit
                      </button>
                      {' '}
                      <button
                        className="admin-materials-btn-danger"
                        onClick={() => handleDelete(material._id)}
                      >
                        Delete
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6" className="no-results">
                    <img
                      src={NotFoundImage}
                      alt="No results"
                      className="no-results-image"
                    />
                    <p>No materials found</p>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {/* Modal for adding/editing material */}
        {show && (
          <div className="admin-materials-modal">
            <div className="admin-materials-modal-content">
              <button className="admin-materials-close-btn" onClick={handleClose}>
                X
              </button>
              <h2>{editingMaterial ? 'Edit Material' : 'Add Material'}</h2>
              <form onSubmit={handleSubmit}>
                <div className="admin-materials-form-group">
                  <label>Name</label>
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    required
                    className="admin-materials-form-control"
                  />
                </div>
                <div className="admin-materials-form-group">
                  <label>Price</label>
                  <input
                    type="number"
                    name="price"
                    value={formData.price}
                    onChange={handleChange}
                    required
                    className="admin-materials-form-control"
                  />
                </div>
                <div className="admin-materials-form-group">
                  <label>Stock</label>
                  <input
                    type="checkbox"
                    name="stock"
                    checked={formData.stock}
                    onChange={handleChange}
                    className="admin-materials-form-check"
                  />
                  In Stock
                </div>
                <div className="admin-materials-form-group">
                  <label>Subtopic</label>
                  <input
                    type="text"
                    name="subtopic"
                    value={formData.subtopic}
                    onChange={handleChange}
                    className="admin-materials-form-control"
                  />
                </div>
                <div className="admin-materials-form-group">
                  <label>Banner</label>
                  <input
                    type="file"
                    name="banner"
                    onChange={handleFileChange}
                    accept=".png, .jpg, .jpeg"
                    className="admin-materials-form-control"
                  />

                </div>
                <button className="admin-materials-btn-primary" type="submit">
                  {editingMaterial ? 'Update Material' : 'Add Material'}
                </button>
              </form>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MaterialManager;
